<template>
  <div>
    <FormComponent @created="refreshList" @clear-prefill="clearPrefill" :prefillData="prefillData" />
    <ListComponent :reload="reloadList" @copy-festival="onCopyFestival" />
  </div>
</template>

<script>
import FormComponent from "@/components/YatriFestival/yatri-festival-form.vue";
import ListComponent from "@/components/YatriFestival/yatri-festival-list.vue";

export default {
  components: { FormComponent, ListComponent },
  data() {
    return {
      reloadList: false,
      prefillData: null,
    };
  },

  methods: {
    refreshList() {
      this.reloadList = !this.reloadList;
    },
    clearPrefill() {
      this.prefillData = null;
    },
    onCopyFestival(item) {
      this.prefillData = { ...item };
    }
  }
};
</script>
